<template>
  <div class="donate">
    <carousel class="carousel" />
    <donate-panel class="panel" :remainingDuration="remainingDuration" :durationOfToday="durationOfToday" />
    <leaderboard class="leaderboard" />

    <touch class="gotolls" @tap="gotoLiulishuo">去学习</touch>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import actions from '@/store/action-types'

  import Carousel from '@/components/Carousel'
  import DonatePanel from '@/components/DonatePanel'
  import Leaderboard from '@/components/Leaderboard'

  export default {
    name: 'donate',
    created () {
      this.getCarousel()
    },
    activated () {
      this.getUserOverview()
      this.$track.sendPageTrack('csr_home')
    },
    computed: {
      ...mapState({
        ccPurchaseStatus: state => state.ccPurchaseStatus,
        joined: state => state.activity.joined,
        remainingDuration: state => state.overview.remainingDuration,
        durationOfToday: state => state.overview.durationOfToday
      })
    },
    methods: {
      getCarousel () {
        this.$store.dispatch(actions.fetch.LATEST_DONATE)
      },
      getUserOverview () {
        this.$store.dispatch(actions.fetch.USER_OVERVIEW)
      },
      gotoLiulishuo () {
        this.$track.sendActionTrack('csr_home', 'click_go_study')
        this.$nativeAPI.invoke('navigate', JSON.stringify({
          url: 'first_added_course',
          param: null,
          closeWebview: false
        }))
      }
    },
    components: {
      Carousel,
      DonatePanel,
      Leaderboard
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  .donate {
    padding: 30px;
    padding-bottom: 130px;
    box-sizing: border-box;
    .panel,
    .leaderboard {
      margin-top: 30px;
    }
    .gotolls {
      @include reset-button;
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 98px;
      font-size: 36px;
      font-weight: bold;
      color: $white;
      line-height: 98px;
      text-align: center;
      background-color: $red;
    }
  }
</style>




// WEBPACK FOOTER //
// Donate.vue?316d9daf